<slice-flex-close *ngIf="isClosable && !!element" [closeSectionData]="closeSectionData" (deleteSlice)="deleteSlice()"></slice-flex-close>
<ng-container *ngIf="element">
    <ng-container *ngFor="let slice of slices; trackBy: identify">
        <slot-manager
            [element]="slice.item"
            [slot]="slice.slot"
            [direction]="direction"
            [resolution]="resolution"
            [hasLogoSections]="hasLogoSections"
        >
        </slot-manager>
    </ng-container>
</ng-container>
